import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl mb-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Showing Posts by Tag: ")
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_posts = _resolveComponent("posts")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", {
        class: "tag-name",
        textContent: _toDisplayString(_ctx.routeTag)
      }, null, 8, _hoisted_3)
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_posts, {
          key: 0,
          posts: _ctx.posts
        }, null, 8, ["posts"]))
      : (_openBlock(), _createBlock(_component_loader, { key: 1 }))
  ]))
}